function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "45px",
    height: "29px",
    viewBox: "0 0 45 29",
    style: {
      enableBackground: "new 0 0 45 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.3 7.8-5.6 13.4H8L5.3 10.5c-.2-.6-.4-.9-.9-1.2-.8-.4-2.2-.8-3.4-1.1l.1-.4H7c.8 0 1.4.5 1.6 1.4l1.5 7.8 3.6-9.1 3.6-.1zm14.4 9c0-3.5-4.9-3.7-4.9-5.3 0-.5.5-1 1.5-1.1.5-.1 1.9-.1 3.4.6l.6-2.8c-.8-.3-1.9-.6-3.3-.6-3.4 0-5.9 1.8-5.9 4.4 0 1.9 1.7 3 3 3.7 1.4.7 1.8 1.1 1.8 1.7 0 .9-1.1 1.3-2.1 1.3-1.7 0-2.8-.5-3.6-.8l-.6 2.9c.8.4 2.3.7 3.9.7 3.8-.1 6.2-1.9 6.2-4.7m9.1 4.4H44L41.2 7.8h-3c-.7 0-1.2.4-1.5 1l-5.2 12.4h3.6l.7-2h4.5l.5 2zm-3.9-4.7 1.8-5 1.1 5h-2.9zM22.3 7.8l-2.9 13.4h-3.5l2.9-13.4h3.5z",
    style: {
      fill: "#1434cb"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.0dbe36df6b1ed20cf80a411ef26ddd03.svg";
export { ForwardRef as ReactComponent };